module.exports = __webpack_public_path__ + "img/Screen-R@2x-design.96f9b14b.png";